import { render } from "./DragProgressPage.vue?vue&type=template&id=3de7839e&scoped=true"
import script from "./DragProgressPage.vue?vue&type=script&lang=js"
export * from "./DragProgressPage.vue?vue&type=script&lang=js"

import "./DragProgressPage.vue?vue&type=style&index=0&id=3de7839e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3de7839e"]])

export default __exports__